











import { Component, Vue } from "vue-property-decorator";
import { VueStore } from "@/store/root-state";
import cookie from "cookie";
import CookieBanner from "./components/layout/CookieBanner.vue";
import Header from "./components/layout/Header.vue";
import Footer from "./components/layout/Footer.vue";

@Component({
  components: {
    CookieBanner,
    Header,
    Footer
  }
})
export default class App extends Vue {
  $store!: VueStore;
  showCookieBanner = false;
  showFullHeader = true;

  mounted() {
    if (!cookie.parse(document.cookie).emocoAcceptCookies) {
      this.showCookieBanner = true;
    }
    
  }

  acceptCookies() {
    this.showCookieBanner = false;
    document.cookie = "emocoAcceptCookies=1;path=/";
  }
}
